import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    id: string
    eyebrow: string
    title: ReactNode
    intro?: ReactNode
    aside?: ReactNode
    align?: 'left' | 'center'
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    id,
    eyebrow,
    title,
    intro,
    aside,
    align = 'left',
    className
}): ReactNode => {
    return (
        <div className={cn('reveal', align === 'center' && 'mx-auto text-center', className)}>
            <div className={cn('flex flex-wrap items-center gap-3', align === 'center' && 'justify-center')}>
                <p className='text-xs font-semibold tracking-[0.18em] text-orange uppercase'>
                    {eyebrow}
                </p>

                {aside}
            </div>

            <h2
                id={id}
                className='mt-4 max-w-3xl text-[2rem] leading-[1.08] font-bold tracking-[-0.025em] text-soft-white sm:text-[2.75rem]'
            >
                {title}
            </h2>

            {intro && (
                <p className={cn('mt-5 max-w-2xl text-lg leading-relaxed text-cool-grey-light', align === 'center' && 'mx-auto')}>
                    {intro}
                </p>
            )}
        </div>
    )
}
